export default __webpack_public_path__ + "static/media/hero.dbe81afc.svg";